import { styled, css } from '@vebox/etui-system';
import { Component, createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, c as _defineProperty, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import ClickOutside from '../ClickOutside/ClickOutside.js';

const _excluded = ["theme"];
const TooltipBubble = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    position: 'absolute',
    'min-width': '120px',
    'max-width': '210px',
    'z-index': 10,
    'font-family': theme.typography.fontFamily,
    'font-size': theme.typography.fontSizeBase,
    'font-weight': theme.typography.fontWeightRegular,
    'line-height': theme.typography.lineHeightBase
  }, props);
})`
  &::after {
    content: '';
    position: absolute;
  }

  ${({
  placement,
  gap,
  bg,
  theme
}) => placement === 'top' && css`
      bottom: ${gap ? `calc(${gap} + 100%)` : '100%'};
      left: 50%;
      padding-bottom: 9px;
      transform: translateX(-50%);
      &::after {
        border-left: 9px solid transparent;
        border-right: 9px solid transparent;
        border-top: 9px solid ${bg || theme.palette.primary.main};
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    `};

  ${({
  placement,
  gap,
  bg,
  theme
}) => placement === 'bottom' && css`
      top: ${gap ? `calc(${gap} + 100%)` : '100%'};
      left: 50%;
      padding-top: 9px;
      transform: translateX(-50%);
      &::after {
        border-left: 9px solid transparent;
        border-right: 9px solid transparent;
        border-bottom: 9px solid ${bg || theme.palette.primary.main};
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    `};

  ${({
  placement,
  gap,
  bg,
  theme
}) => placement === 'left' && css`
      top: 50%;
      right: ${gap ? `calc(${gap} + 100%)` : '100%'};
      padding-right: 9px;
      transform: translateY(-50%);
      &::after {
        border-left: 9px solid ${bg || theme.palette.primary.main};
        border-top: 9px solid transparent;
        border-bottom: 9px solid transparent;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    `};

  ${({
  placement,
  gap,
  bg,
  theme
}) => placement === 'right' && css`
      top: 50%;
      left: ${gap ? `calc(${gap} + 100%)` : '100%'};
      padding-left: 9px;
      transform: translateY(-50%);
      &::after {
        border-right: 9px solid ${bg || theme.palette.primary.main};
        border-top: 9px solid transparent;
        border-bottom: 9px solid transparent;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    `};
`;

const _excluded$1 = ["theme", "warning", "warningWidth"];
const TooltipMessage = styled(Div).attrs(_ref => {
  let {
      theme,
      warning,
      warningWidth
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return _objectSpread2({
    bg: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: '2px',
    p: `${theme.spacing.sm}px`,
    fontSize: theme.typography.fontSizeSmall,
    width: warning && warningWidth,
    ml: warning && '50px'
  }, props);
})`
  font-weight: normal;
  line-height: 1.25;
  text-align: center;
  word-break: normal;
`;

class Tooltip extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "renderMessage", () => {
      const {
        message
      } = this.props;
      if (typeof message === 'function') {
        return message();
      }
      return message;
    });
    _defineProperty(this, "isVisibleNotDefined", () => {
      return typeof this.props.isVisible === 'undefined';
    });
    _defineProperty(this, "hideTooltip", () => {
      if (this.isVisibleNotDefined()) {
        this.setState({
          open: false
        });
      }
    });
    _defineProperty(this, "showTooltip", () => {
      if (this.isVisibleNotDefined()) {
        this.setState({
          open: true
        });
      }
    });
    this.state = {
      open: props.isVisible !== undefined ? props.isVisible : false
    };
  }
  render() {
    const {
      placement,
      children,
      additionalGap,
      isDisabledOnMobile,
      styles,
      disableToolTip = false,
      warning,
      warningWidth
    } = this.props;
    return /*#__PURE__*/createElement(ClickOutside, {
      onClickOutside: this.hideTooltip,
      enableOnMouseLeave: true,
      styles: {
        root: _objectSpread2({
          position: 'relative',
          display: 'inline-block'
        }, styles.root)
      }
    }, this.state.open && /*#__PURE__*/createElement(TooltipBubble, _extends({
      placement: placement,
      gap: additionalGap
    }, styles.bubble), /*#__PURE__*/createElement(TooltipMessage, {
      warning: warning,
      warningWidth: warningWidth
    }, this.renderMessage())), /*#__PURE__*/createElement(Div, _extends({
      onFocus: disableToolTip ? this.hideTooltip : this.showTooltip,
      onMouseOver: disableToolTip ? this.hideTooltip : this.showTooltip,
      onTouchStart: disableToolTip ? this.hideTooltip : isDisabledOnMobile ? null : this.showTooltip,
      onMouseLeave: this.hideTooltip
    }, styles.div), children));
  }
}
_defineProperty(Tooltip, "defaultProps", {
  placement: 'top',
  styles: {}
});

export default Tooltip;
